define('viewmodels/pages/games/gamesHeader',['knockout'], function (ko) {

    var GamesHeader = function (session, welcomeOffers, getOnboardingField, tournamentCampaigns) {

        var self = this,
            player = session.getAssociatedPlayer;

        self.welcomeOffer = ko.pureComputed(function () {
            return welcomeOffers.findOfferById(player().welcomeOfferId())();
        });

        self.showBalance = ko.pureComputed(function () {
            return session.loggedIn() && !self.showWelcomeOffer();
        });

        self.showWelcomeOffer = ko.pureComputed(function () {
            return session.loggedIn() &&
                self.welcomeOffer() &&
                !player().hasDeposited() &&
                player().depositBonus.hasDepositBonusItems();
        });

        self.welcomeOfferTitle = getOnboardingField('post_signup_welcome_offer_title');
        self.welcomeOfferText = getOnboardingField('post_signup_welcome_offer_text');

        self.activeTournamentCampaign = tournamentCampaigns.activeCampaign;

    };

    return GamesHeader;
});


